{
  "queryName": "curatorSummaryStatistics",
  "queryParam": null,
  "fields": []
}
